import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { F as FirstPageIcon } from './icons/FirstPageIcon-Dn5LC_xU.js';
import { P as PaginationButton } from './PaginationButton-rb5yV7v2.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const PaginationFirstButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-first-button')
}, props), /*#__PURE__*/React__default.createElement(FirstPageIcon, null));
PaginationFirstButton.displayName = 'PaginationFirstButton';

export { PaginationFirstButton as P };
//# sourceMappingURL=PaginationFirstButton-Cpk8f2xH.js.map
